import React from 'react';

var Success = function Success() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    "aria-label": "Success Icon",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7613 4.21934C13.9017 4.35997 13.9806 4.55059 13.9806 4.74934C13.9806 4.94809 13.9017 5.13871 13.7613 5.27934L6.51127 12.5293C6.37064 12.6698 6.18002 12.7487 5.98127 12.7487C5.78252 12.7487 5.59189 12.6698 5.45127 12.5293L2.20127 9.27934C2.06886 9.13708 1.99676 8.94903 2.00011 8.75471C2.00347 8.56039 2.08202 8.37494 2.21927 8.23734C2.35687 8.1001 2.54232 8.02154 2.73664 8.01818C2.93095 8.01483 3.11901 8.08693 3.26127 8.21934L5.98127 10.9393L12.7013 4.21934C12.8419 4.07889 13.0325 4 13.2313 4C13.43 4 13.6206 4.07889 13.7613 4.21934Z",
    fill: "#176F2C"
  })));
};
Success.displayName = "Success";

export { Success as default };
